import { Mode } from '../../../../utils';
import { mergeDeep } from '../../../../utils/Helper';

export const initialize = (props) => {
  return (initialState) => {
    let state = mergeDeep(
      { ...initialState },
      {
        ui: {
          mode: props.mode || Mode.EDIT,
          loading: props.retriveAsync
        },
        collateral: {
          ...props.collateral,
        },
        collateralWarrantyItem: {
          ...props.collateralWarrantyItem,
        },
      }
    );
    if (state.ui.mode == Mode.READONLY) {
      Object.keys(state.collateral).forEach(f => {
        state.fields.readonly[f] = true;
      })

      state.buttons.precheck.readonly = true;
    }

    return state;
  }
}

export const defaultState = () => ({
  ui: {
    title: 'General Collateral Pool',
    mode: Mode.EDIT
  },
  fields: {
    errors: {},
    readonly: {},
    hiddens: {}
  },
  collateral: {
    id: null,
    Accountid: null,
    Accountname: null,
    GCPoolRelated: null,
    GCPoolRelatedEntityId: null,
    GCPoolTrackTransfers: null,
    status: "active",
    collaterals: [],
    products: [],
    Margin: null,
    Poolname: null,
    TotalAvilable: null,
    TotalRequiered: null,
    TrackTransfers: false,
  },
  collateralWarrantyItem: {
    AssetId: null,
    AssetTicker: null,
    CollateralAppraisal: null,
    CollateralId: null,
    CollateralMargin: null,
    CollateralMaturity: null,
    CollateralQuantity: null,
    CollateralStatus: "Active",
  },

  buttons: {
    confirm: {
      visible: false
    },
    precheck: {
      visible: true
    },
  },
})